// @ts-strict-ignore
import React from 'react';
import { PageContainer } from '../components/pageContainer';

import { Text } from '../components/text';
import { AuthContainer } from '../components/authContainer';

export const Disabled: React.FC = () => {
  return (
    <PageContainer header={null} leftNav={null}>
      <AuthContainer title="Login Failed">
        <Text variant="md">Your account has been disabled.</Text>
        <Text variant="md">If you have any questions, please contact Prisms at support@prismsvr.com</Text>
      </AuthContainer>
    </PageContainer>
  );
};
